import React from 'react'

const Translation = (props) => {
    return (
        <div className='col-12 mx-auto'>
            <h1 className='display-1'>Translation in progress</h1>
        </div>
    )
}

export default Translation
